<template>
  <v-list v-if="discounts.length > 0" class="mb-3">
    <template v-for="(discount, discountIndex) in discounts">
      <section :key="discount.OrderItemId">
        <v-list-item>
          <v-list-item-avatar size="35">
            <v-icon color="primary">local_offer</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ discount.Name }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action v-if="smAndUp">
            <h4 class="red--text">
              {{ formatter.format(getDiscountPrice(discount)) }}
              <span v-if="isProfUser" class="text-caption text--secondary">
                {{ $translate('EXCL_VAT') }}
              </span>
            </h4>
          </v-list-item-action>
        </v-list-item>

        <h4 v-if="!smAndUp" class="red--text text-right px-3">
          {{ formatter.format(getDiscountPrice(discount)) }}
          <span v-if="isProfUser" class="text-caption text--secondary">
            {{ $translate('EXCL_VAT') }}
          </span>
        </h4>

        <v-divider
          v-if="discountIndex < discounts.length - 1"
          :key="discountIndex"
          class="mx-1"
        ></v-divider>
      </section>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'ShoppingListDiscounts',
  props: {
    discounts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isProfUser() {
      return this.$store.getters.isProfUser;
    },
    smAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  methods: {
    getDiscountPrice(discount) {
      if (this.isProfUser) {
        return discount.Price - discount.VatPrice;
      }
      return discount.Price;
    },
  },
};
</script>
